function params(query) {
  let arr = [];
  for (let key in query) {
    arr.push(key + '=' + encodeURIComponent(query[key]));
  }
  return arr.join('&');
}

function addParams(url, query) {
  let urlParts = url.split('#');
  urlParts[0] += (urlParts[0].indexOf('?') == -1) ? '?' : '&';
  urlParts[0] += params(query);
  return urlParts.join('#');
}

module.exports = img => {
  if (img.complete && img.naturalWidth) return;
  img.src = addParams(img.src, { __t: Date.now() });
};
